<template>
  <div v-once></div>
</template>

<script>
import { mapState } from "vuex";
import { pleaseWait } from 'please-wait'
import 'please-wait/build/please-wait.css'
export default {
  computed: {
    ...mapState({
      isLoading: (state) => state.loading.isLoading,
    }),
  },
  watch: {
    isLoading: {
      handler(isLoading) {
        if (isLoading) {
          this.open();
        } else {
          this.close();
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.close();
  },
  methods: {
    open() {
      if (!this.pleaseWaitInstance) {
        this.pleaseWaitInstance = pleaseWait({
          logo: "https://assets-intranet-security.s3.us-east-2.amazonaws.com/Bice-Cargando+(1).gif",
          backgroundColor: "#FFF",
          loadingHtml: "",
        });
      }
    },
    close() {
      if (this.pleaseWaitInstance) {
        this.pleaseWaitInstance.finish();
        this.pleaseWaitInstance = null;
      }
    },
  },
};

</script>

<style>
.loading-message {
  color: white;
}
.spinner {
  margin: 100px auto;
  width: 50px;
  height: 40px;
  text-align: center;
  font-size: 10px;
}

.spinner > div {
  background-color: white;
  height: 100%;
  width: 6px;
  display: inline-block;
  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
  margin-left: 2px;
}

.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
  margin-left: 2px;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
  margin-left: 2px;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
  margin-left: 2px;
}

@-webkit-keyframes sk-stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  
  20% { -webkit-transform: scaleY(1.0) }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% { 
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% { 
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}

.pg-loading-screen .pg-loading-logo-header img {
    display: inline-block !important;
}

@media screen and (min-width: 300px) and (max-width: 768px) {
  .pg-loading-logo {
    width: 60%;
  }
}

@media screen and (min-width: 769px) {
  .pg-loading-logo {
    width: 28%;
  }
}

</style>
